import { expVal } from '@atlassian/jira-feature-experiments';
import type { FlagConfiguration } from '@atlassian/jira-flags';
import messages from './messages.tsx';

const DEFAULT_ERROR_FLAG: FlagConfiguration = {
	type: 'error',
	title: messages.defaultErrorTitle,
	description: messages.defaultErrorMessage,
	messageId:
		'horizontal-nav-common.common.get-flag-details.default-error-flag.error.error.default-error-flag',
	messageType: 'transactional',
};

export const getFlagDetails = (statusCode: number): FlagConfiguration => {
	const projectNotFoundErrorTitleGalaxia = expVal('project-terminology-refresh', 'isEnabled', false)
		? messages.projectNotFoundErrorTitleGalaxia
		: messages.projectNotFoundErrorTitle;
	const projectNotFoundErrorMessageGalaxia = expVal(
		'project-terminology-refresh',
		'isEnabled',
		false,
	)
		? messages.projectNotFoundErrorMessageGalaxia
		: messages.projectNotFoundErrorMessage;
	const unauthorizedUserErrorMessageGalaxia = expVal(
		'project-terminology-refresh',
		'isEnabled',
		false,
	)
		? messages.unauthorizedUserErrorMessageGalaxia
		: messages.unauthorizedUserErrorMessage;
	switch (statusCode) {
		case 401:
			return {
				type: 'error',
				title: messages.unauthenticatedUserErrorTitle,
				description: messages.unauthenticatedUserErrorMessage,
				messageId: 'horizontal-nav-common.common.get-flag-details.flag.error.error.401',
				messageType: 'transactional',
			};
		case 403: {
			return {
				type: 'error',
				title: messages.unauthorizedUserErrorTitle,
				description: unauthorizedUserErrorMessageGalaxia,
				messageId: 'horizontal-nav-common.common.get-flag-details.flag.error.error.403',
				messageType: 'transactional',
			};
		}
		case 404: {
			return {
				type: 'error',
				title: projectNotFoundErrorTitleGalaxia,
				description: projectNotFoundErrorMessageGalaxia,
				messageId: 'horizontal-nav-common.common.get-flag-details.flag.error.error.404',
				messageType: 'transactional',
			};
		}
		default: {
			return DEFAULT_ERROR_FLAG;
		}
	}
};
